import type { IMyWorkWireItem } from '@platform/dao';

/**
 * «Призначені вам» у порядку прототипу v4 (Головна: записи збираються за ws.modules простору, далі my.sort за терміном): за терміном
 * (без терміну — наприкінці), однаковий термін — у порядку модулів простору (`rank` типу запису), далі — порядок сервера. Чиста функція.
 */
export function assignedOrder(items: readonly IMyWorkWireItem[], rank: (rtKey: string) => number): IMyWorkWireItem[] {
  return items
    .map((item, i) => ({ item, i, due: item.due ?? '9999', at: rank(item.recordType) }))
    .sort((a, b) => (a.due < b.due ? -1 : a.due > b.due ? 1 : a.at - b.at || a.i - b.i))
    .map((x) => x.item);
}
